/* eslint-disable no-unused-vars */
import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import { NavLink, useNavigate } from "react-router-dom";
//Icon Imports
import IconButton from "@mui/material/IconButton";
import Zoom from "@mui/material/Zoom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import SettingsIcon from "@mui/icons-material/Settings";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { useMediaQuery } from "@mui/material";
import SiteLogo from "../Assets/images/siteLogoWhite.svg";
import { useSelector, useDispatch } from "react-redux";
import {closeExpand,openExpand,trigger,} from "../../redux/reducers/SideExpand";
import { motion, AnimatePresence } from "framer-motion";
import { Tooltip } from "@mui/material";
import configServ from "../../services/config";

// icon
//import BeenhereIcon from '@mui/icons-material/Beenhere';
//import InventoryIcon from "@mui/icons-material/Inventory";
//import CategoryIcon from "@mui/icons-material/Category";
//import Diversity3Icon from "@mui/icons-material/Diversity3";
//import SwapHorizSharpIcon from '@mui/icons-material/SwapHorizSharp';
//import AssessmentSharpIcon from '@mui/icons-material/AssessmentSharp';
//import ApartmentIcon from "@mui/icons-material/Apartment";
//import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
//import VpnKeyIcon from "@mui/icons-material/VpnKey";
//import AndroidIcon from "@mui/icons-material/Android";
//import ExtensionIcon from "@mui/icons-material/Extension";
//import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";
//import AttachEmailIcon from "@mui/icons-material/AttachEmail";

import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing"
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import GroupsIcon from "@mui/icons-material/Groups";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import PeopleIcon from '@mui/icons-material/People';
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
import MarkUnreadChatAltIcon from "@mui/icons-material/MarkUnreadChatAlt";
import EditLocationAltIcon from "@mui/icons-material/EditLocationAlt";
import BadgeIcon from "@mui/icons-material/Badge";
import AppsOutageIcon from "@mui/icons-material/AppsOutage";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import CommentIcon from "@mui/icons-material/Comment";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
//import LocalCarWashIcon from "@mui/icons-material/LocalCarWash";
import ContactlessIcon from "@mui/icons-material/Contactless";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";


// icons as per new design
import DashboardIcon from "@mui/icons-material/Dashboard";
import InventoryIcon from "../Assets/images/Inventorymaster.png";
import CustomerOrderIcon from "../Assets/images/CustomerOrder.png";
import AccountIcon from "../Assets/images/Accountmaster.png";
import TransactionIcon from "../Assets/images/Transaction.png";
import CategoryIcon from "../Assets/images/Category.png";
import ReportsIcon from "../Assets/images/Reports.png";
import BusinessSharpIcon from '@mui/icons-material/BusinessSharp';
import SettingsApplicationsOutlinedIcon from '@mui/icons-material/SettingsApplicationsOutlined';
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import AccessMasterIcon from "../Assets/images/Accessmaster.png";
import MenuPermissionIcon from "../Assets/images/Menupermission.png";
import ReceiptIcon from '@mui/icons-material/Receipt';
import BrandIcon from "../Assets/images/brand.png";
import ItemIcon from "../Assets/images/Item.png";
import HsnIcon from "../Assets/images/HSNIcon.png";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
//import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import FactCheckIcon from '@mui/icons-material/FactCheck';
import PaidIcon from "@mui/icons-material/Paid";
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import { useState } from "react";
import LoaderNew from "../Loader/LoaderNew";
import PortableWifiOffIcon from "@mui/icons-material/PortableWifiOff";
import DevicesFoldIcon from "@mui/icons-material/DevicesFold";
import { ApartmentSharp } from "@mui/icons-material";
import FullfillmentIcon from "../Assets/images/fullfillment.png";
import PurchaseOrderIcon from "../Assets/images/purchaseorder.png";
import CashVoucherIcon from "../Assets/images/cashVouchers.jpg";
import GSTTransactionIcon from "../Assets/images/GST.png";
import DispatchIcon from "../Assets/images/dispatch.png";
import ChallanIcon from "../Assets/images/challan.jpg";
import VendorChallanIcon from "../Assets/images/vendorchallan.jpg";
import { rSetFetchMenuList } from "../../redux/reducers/GlobalVariables";
import CreditNoteIcon from "../Assets/images/credit.png";
import PurchaseBillIcon from "../Assets/images/purchasebill.png";
import SalesSummary2Icon from "../Assets/images/salessummary2.png";
import ChallanReportIcon from "../Assets/images/challanreport.png";
import StockReportIcon from "../Assets/images/StockReport.png";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const NavToolTip = ({ text, children }) => {
  return (
    <Tooltip
      TransitionComponent={Zoom}
      leaveDelay={200}
      title={text}
      placement="right"
      arrow
      sx={{ fontSize: "16px" }}
    >
      {children}
    </Tooltip>
  );
};

export default function Sidebar() {
  //#region code
  const dispatch = useDispatch();
  const open = useSelector((state) => state.sideExpand.open);
  const isMobile = useMediaQuery("(max-width:600px)");

  const { is_super, is_admin, permissions, company_id , fetch_menu_list } = useSelector(
    (state) => state.GlobalVariables,
  );

  // eslint-disable-next-line no-unused-vars
  const { company_type } = useSelector((state) => state.admin);

  const [isMenuExpanded, setIsMenuExpanded] = React.useState(false);
  const [selectedMenu, setSelectedMenu] = React.useState(0);

  React.useEffect(() => {
    if (isMobile) {
      dispatch(closeExpand());
    } else {
      dispatch(openExpand());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);

  const handleDrawerOpen = () => {
    dispatch(trigger());
  };

  const handleDrawerClose = () => {
    // setOpen(false);
    dispatch(trigger());
  };

  const handleExpand = (number) => {
    setSelectedMenu(number);
    setIsMenuExpanded(!isMenuExpanded);
  };

  const navigate = useNavigate();
  const [expandedMenu, setExpandedMenu] = React.useState(null); // Track expanded menu
  const [menus, setMenus] = React.useState([]);

  const handleMenuClick = (menu) => {
    if (menu.submenus.length === 0) {
      navigate(menu.routes); // Navigate directly
    } else {
      setExpandedMenu(expandedMenu === menu.id ? null : menu.id); // Toggle submenu
    }
  };
  
  const handleSubmenuClick = (route) => {
    navigate(route);
  };

  const [loading, setLoading] = useState(false);

  const fetchMenuList = React.useCallback(async () => {
    setLoading(true);
    try {
      const res = await configServ.getActiveMenusWithSubmenus();
      if (res.status === 200 && Array.isArray(res.data)) {
        setMenus(res.data || []);
      } else {
        setMenus([]);
        // toast.error("Failed to fetch menu list.");
      }
    } catch (e) {
      // toast.error("An error occurred!");
      console.log(e);
      setMenus([]);
    } finally {
      setLoading(false);
      dispatch(rSetFetchMenuList(false)); // Reset the fetch_menu_list flag after fetching
    }
  }, [dispatch]);

  React.useEffect(() => {
    fetchMenuList();
  }, [fetch_menu_list, fetchMenuList]); // Refetch menu list when fetch_menu_list changes

  // Icon mapping object

  const iconMapping = {
    dashboard: <DashboardIcon />,
    //inventory: <InventoryIcon />,
    inventory: (
    <img
    // eslint-disable-next-line no-undef
    src={InventoryIcon}
    alt="inventorymaster"
    width="17"
    height="18"
    style={{
      objectFit: "contain",
      filter: "invert(1)"
    }}
    />
    ),
    //sales: <ShoppingCartCheckoutIcon />,
    sales: (
    <img
    src={CustomerOrderIcon}
    alt="customerorder"
    width="17"
    height="18"
    style={{
      objectFit: "contain",
      filter: "invert(1)"
    }}
    />
    ),
    //account: <Diversity3Icon />,
    account: (
    <img
    src={AccountIcon}
    alt="account"
    width="17"
    height="18"
    style={{
      objectFit: "contain",
      filter: "invert(1)"
    }}
    />
    ),
    //transaction: <SwapHorizSharpIcon/>,
    transaction: (
    <img
      src={TransactionIcon}
      alt="transaction"
      width="17"
      height="18"
      style={{
      objectFit: "contain",
      filter: "invert(1)"
      }}
    />
    ),
    //reports: <AssessmentSharpIcon />,
    reports: (
    <img
    src={ReportsIcon}
    alt="reports"
    width="17"
    height="18"
    style={{
      objectFit: "contain",
      filter: "invert(1)"
    }}
    />
    ),
    //companyregister: <ApartmentIcon />,
    companyregister: <BusinessSharpIcon />,
    configuration: <SettingsApplicationsOutlinedIcon />,
    profile: <AccountBoxIcon />,
    //accessmaster: <VpnKeyIcon />,
    accessmaster: (
    <img
    src={AccessMasterIcon}
    alt="accessmaster"
    width="18"
    height="18"
    style={{
      objectFit: "contain",
      filter: "invert(1)"
    }}
    />
    ),
    //menupermission: <AdminPanelSettingsIcon />,
    menupermission: (
    <img
    src={MenuPermissionIcon}
    alt="Menupermission"
    width="18"
    height="18"
    style={{
      objectFit: "contain",
      filter: "invert(1)"
    }}
    />
    ),
    invoice: <ReceiptIcon />,
    dispatchschedule: <CalendarMonthIcon />,
    //fullfillment icon 
    fullfillment: (
    <img
      src={FullfillmentIcon}
      alt="transaction"
      width="17"
      height="18"
      style={{
      objectFit: "contain",
      filter: "invert(1)"
      }}
    />
    ),
    //purchase  order icon
    purchaseorder: (
    <img
    src={PurchaseOrderIcon}
    alt="purchaseorder"
    width="22"
    height="22"
    style={{
      objectFit: "contain",
      filter: "invert(1)"
    }}
    />
    ),
    //brand: <AndroidIcon />,
    brand: (
    <img
    src={BrandIcon}
    alt="brand"
    width="18"
    height="18"
    style={{
      objectFit: "contain",
      filter: "invert(1)"
    }}
    />
    ),
    //category: <CategoryIcon />,
    category: (
    <img
    src={CategoryIcon}
    alt="category"
    width="17"
    height="18"
    style={{
      objectFit: "contain",
      filter: "invert(1)"
    }}
    />
    ),
    group: <GroupsIcon />,
    unit: <AcUnitIcon />,
    //item: <ExtensionIcon />,
    item: (
    <img
    src={ItemIcon}
    alt="item"
    width="17"
    height="18"
    style={{
      objectFit: "contain",
      filter: "invert(1)"
    }}
    />
    ),
    //hsn: <AutoAwesomeMotionIcon />,
    hsn: (
    <img
    src={HsnIcon}
    alt="hsn"
    width="18"
    height="18"
    style={{
      objectFit: "contain",
      filter: "invert(1)"
    }}
    />
    ),
    supplier: <PrecisionManufacturingIcon />,
    //cashvoucher: <ReceiptIcon />,
    cashvoucher: (
    <img
    src={CashVoucherIcon}
    alt="cashvoucher"
    width="18"
    height="18"
    style={{
      objectFit: "contain",
      filter: "invert(1)"
    }}
    />
    ),
    //gst: <AccountBalanceWalletIcon />,
    gst: (
    <img
    src={GSTTransactionIcon}
    alt="gsttransaction"
    width="18"
    height="18"
    style={{
      objectFit: "contain",
      filter: "invert(1)"
    }}
    />
    ),
    journal: <ReceiptLongIcon />,
    //dispatch: <LocalCarWashIcon />, //DISPATCH , CREDIT NOTE
    dispatch: (
    <img
    src={DispatchIcon}
    alt="dispatch"
    width="18"
    height="18"
    style={{
      objectFit: "contain",
      filter: "invert(1)"
    }}
    />
    ),
    challan: (
    <img
    src={ChallanIcon}
    alt="challan"
    width="18"
    height="18"
    style={{
      objectFit: "contain",
      filter: "invert(1)"
    }}
    />
    ),
    vendorchallan: (
    <img
    src={VendorChallanIcon}
    alt="vendorchallan"
    width="18"
    height="18"
    style={{
      objectFit: "contain",
      filter: "invert(1)"
    }}
    />
    ),
    
    creditnote: (
    <img
    src={CreditNoteIcon}
    alt="creditnote"
    width="18"
    height="18"
    style={{
      objectFit: "contain",
      filter: "invert(1)",
    }}
    />
    ),
    
    super: <SupervisedUserCircleIcon />,
    subscriptions: <SubscriptionsIcon />,
    //purchasebill: <PaidIcon />,
    purchasebill: (
    <img
    src={PurchaseBillIcon}
    alt="purchasebill"
    width="18"
    height="18"
    style={{
      objectFit: "contain",
      filter: "invert(1)",
    }}
    />
    ),

    location: <AddLocationAltIcon />,
    //salessummary2: <AttachEmailIcon />,
    salessummary2: (
    <img
      src={SalesSummary2Icon}
      alt="salessummary2"
      width="18"
      height="18"
      style={{
        objectFit: "contain",
        filter: "invert(1)",
      }}
    />
    ),
    challanreport: (
    <img
    src={ChallanReportIcon}
    alt="challanreport"
    width="18"
    height="18"
    style={{
      objectFit: "contain",
      filter: "invert(1)",
    }}
    />
    ),
    stockreport: (
    <img
    src={StockReportIcon}
    alt="stockreport"
    width="18"
    height="18"
    style={{
      objectFit: "contain",
      filter: "invert(1)",
    }}
    />
    ),
    //super: <SupervisedUserCircleIcon />,
    //subscriptions: <SubscriptionsIcon />,
    //location: <AddLocationAltIcon />,
    catalog: <CastForEducationIcon />,
    customers: <PeopleIcon />,
    lead: <LeaderboardIcon />,
    master: <FamilyRestroomIcon />,
    stockupdate: <FactCheckIcon />,
    puchaseorder: <ShoppingBagIcon />,
    //purchasebill: <PaidIcon />,
    outstanding: <AppsOutageIcon />,
    gstreport: <CommentIcon />,
    salesreport: <ForwardToInboxIcon />,
    salessummary: <AssessmentIcon />,
    //salessummary2: <AttachEmailIcon />,
    trial: <AssuredWorkloadIcon />,
    ledger: <BadgeIcon />,
    loghistory: <EditLocationAltIcon />,
    unregister: <MarkUnreadChatAltIcon />,
    salescancel: <PortableWifiOffIcon />,
    invoicecancel: <DevicesFoldIcon />,
  };

  const getIcon = (iconName) => {
    return iconMapping[iconName.toLowerCase()] || null ; // Return null if icon doesn't exist 
    
  };

  // permission

  // Function to filter menus based on permissions
  const filterMenus = (menus) => {
    if (is_admin || is_super) return menus; // Show all menus if is_admin or is_super is true

    return menus
      .map((menu) => {
        // 🔥 Hide Challan menu if disabled

        // Check menu permission
        const hasMenuPermission = permissions.includes(menu.permission);

        // Filter submenus based on their permissions
        const filteredSubmenus = menu.submenus.filter((submenu) =>
          submenu.permission ? permissions.includes(submenu.permission) : false,
        );

        // Include menu if it has permission or has filtered submenus
        if (hasMenuPermission || filteredSubmenus.length > 0) {
          return { ...menu, submenus: filteredSubmenus };
        }
        return null;
      })
      .filter((menu) => menu !== null); // Remove menus that don't have permission and no valid submenus
  };

  // Get filtered menus
  const filteredMenus = filterMenus(menus);
  //#endregion

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Drawer
        variant="permanent"
        open={open}
        PaperProps={{
          sx: {
            backgroundColor: "#333",
          },
        }}
      >
        <DrawerHeader
          sx={{
            display: "flex",
            alignItems: "center", // Vertically centers content
            justifyContent: "space-between",
            padding: "0 8px",
            minHeight: "48px", // Adjust as needed for compactness
          }}
        >
          {open && (
            <img
              src={SiteLogo}
              alt="logo"
              width="150"
              height="90" // Explicit height to prevent extra space
              style={{
                display: "block", // Prevents inline images from adding extra space
                margin: 0,
                padding: 0,
              }}
            />
          )}
          <IconButton onClick={handleDrawerClose}>
            {open ? (
              <ArrowBackIosNewIcon sx={{ color: "white" }} />
            ) : (
              <ArrowForwardIosIcon sx={{ color: "white" }} />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />

        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LoaderNew /> {/* Replace with your loader icon/component */}
          </div>
        ) : (
          <>
            {" "}
            {/* Iterate Menus */}
            {filteredMenus.map((menu) => (
              <div key={menu.id}>
                {/* Main Menu */}
                <div
                  onClick={() => handleMenuClick(menu)}
                  style={{
                    cursor: "pointer",
                    padding: "10px",
                    color: "white",
                    display: "flex",
                    justifyContent: open ? "space-between" : "center",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px", // Add spacing between icon and name
                    }}
                  >
                    <NavToolTip text={menu.name}>
                      {getIcon(menu.icon)}
                    </NavToolTip>{" "}
                    {open && menu.name}
                  </span>
                  {menu.submenus.length > 0 &&
                    (expandedMenu === menu.id ? (
                      <ArrowDropUpIcon />
                    ) : (
                      <ArrowDropDownIcon />
                    ))}
                </div>

                {/* Submenus */}
                <AnimatePresence>
                  {expandedMenu === menu.id && menu.submenus.length > 0 && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <ul style={{ listStyle: "none", paddingLeft: "20px" }}>
                        {menu.submenus.map((submenu) => (
                          <li key={submenu.id}>
                            <div
                              onClick={() => handleSubmenuClick(submenu.routes)}
                              style={{
                                cursor: "pointer",
                                padding: "8px",
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                                gap: "12px", // Add spacing for submenu items
                              }}
                            >
                              <NavToolTip text={submenu.name}>
                                {getIcon(submenu.icon)}
                              </NavToolTip>
                              {open && submenu.name}{" "}
                              {/* Only show name if sidebar is open */}
                            </div>
                          </li>
                        ))}
                      </ul>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </>
        )}
      </Drawer>
    </Box>
  );
}
